import React, { useState, useCallback } from 'react';
import { Modal, Input, Checkbox } from '../..';
import {
    Divider,
    Typography,
    Grid,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    ListItem,
    ListItemText,
    List, ListItemIcon
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { withStyles } from '@material-ui/core/styles';
import { styles } from '../CampaignPromo.styles';
import { mainColor } from '../../../constants';
import moment from 'moment';
import { PRODUCTDISCOUNT, PRODUCTDISCOUNTAFTERTHRESHOLD, BUYONEGETONEDIFFERENTPRODUCT, CAMPAIGN_ITEMS, EXPANDABLE_SECTIONS } from '../../../constants/marketingCampaign';
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined';
import IconButton from '../../IconButton';
import Button from '../../Button';
import _ from 'lodash';
import { handleProductToggle, handleDateChange, handleDelete, handlePurchasedProductToggle, handleOfferedProductToggle, handleAddOfferedProducts, handleAddProducts } from '../CampaignPromo.services';
import { getOffersFromConfig, getProductDetailsFromConfig } from '../../../utils/product';
import { InputField, DatePickerField } from './FormFields'
const StyledAccordion = withStyles({
    root: {
        border: 'none',
        boxShadow: 'none',
        margin: '0 !important',
        padding: '0',
        '&:before': { display: 'none' },
        '&$expanded': { margin: '0 !important' },
    },
    expanded: {},
})(Accordion);

const StyledAccordionSummary = withStyles({
    root: {
        minHeight: '45px !important',
        height: '45px',
        padding: '0 12px',
        '&$expanded': { minHeight: '45px !important', height: '45px' },
    },
    content: {
        margin: '0 !important',
        '&$expanded': { margin: '0 !important' },
        alignItems: 'center',
    },
    expanded: {},
    expandIcon: {
        '&:hover': {
            backgroundColor: `rgba(${mainColor.rgb}, 0.5)`
        },
        padding: '7px 7px 7px 7px'
    },
})(AccordionSummary);
const CustomAccordionSummary = withStyles({
    root: {
        minHeight: '45px !important',
        height: '45px',
        padding: '0 12px',
        '&$expanded': { minHeight: '45px !important', height: '45px' },
    },
    content: {
        margin: '0 !important',
        '&$expanded': { margin: '0 !important' },
        alignItems: 'center',
    },
    expanded: {},
    expandIcon: {
        marginRight: '0px !important',
        transform: 'rotate(0deg)',
        transition: 'transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
        '&$expanded': {
            transform: 'rotate(180deg)',
        },
        '&:hover': {
            backgroundColor: `rgba(${mainColor.rgb}, 0.5)`
        },
        padding: '7px 7px 7px 7px'
    },
})(AccordionSummary);

const CampaignProductsModal = ({
    classes,
    showModal,
    loading,
    handleClose,
    selectedCampaign,
    onClick,
    selectedShops,
    allMenus,
    openErrorModal,
    isUpdate,
    sections
}) => {

    const [expandedPurchased, setExpandedPurchased] = useState(true);
    const [expandedOffered, setExpandedOffered] = useState(false);
    const { type, config, dateEnd, dateStart, marketingCampaignKey, shopIds } = selectedCampaign
    const { title, description, inputDescription, inputText, id, valueType } = isUpdate ? CAMPAIGN_ITEMS.filter(item => type === item.id)?.[0] : selectedCampaign;
    const offers = isUpdate ? getOffersFromConfig(allMenus, config?.products, shopIds[0]) : [];
    const choosedProducts = isUpdate ? getProductDetailsFromConfig(allMenus, config?.products, shopIds[0], true) : [];
    const [selectedProducts, setSelectedProducts] = useState<any>(offers);
    const [disabledPurshasedProducts, setDisabledPurshasedProducts] = useState<any>([]);
    const [offeredProducts, setOfferedProducts] = useState<Array<{
        productKey: string;
        productOfferedKey: string;
        productSectionKey: string;
        productOfferedSectionKey: string;
        productName: string;
        productOfferedName: string;
    }>>(config?.products || []);
    const [purchasedProducts, setPurchasedProducts] = useState<Array<{
        productKey: string,
        productOfferedKey: string,
        productName: string,
        productSectionKey: string,
        productOfferedSectionKey: string,
        productOfferedName: string,
    }>>(choosedProducts);
    const withButton = id !== PRODUCTDISCOUNT && id !== PRODUCTDISCOUNTAFTERTHRESHOLD;

    const getInitialExpandedSection = () => {
        if (id === PRODUCTDISCOUNT || id === PRODUCTDISCOUNTAFTERTHRESHOLD) {
            return EXPANDABLE_SECTIONS.DISCOUNT;
        } else {
            return EXPANDABLE_SECTIONS.PRODUCTLIST;
        }
    };

    const [expandedLeftSection, setExpandedLeftSection] = useState(getInitialExpandedSection());
    const defaultStartTime = moment().add(30, 'minutes');
    const [formValues, setFormValues] = useState({
        startDate: dateStart ? moment(dateStart).toDate() : moment().toDate(),
        endDate: dateEnd ? moment(dateEnd).toDate() : moment().add(1, 'day').toDate(),
        startTime: dateStart ? moment(dateStart).format('HH:mm') : defaultStartTime.format('HH:mm'),
        endTime: dateEnd ? moment(dateEnd).format('HH:mm') : '23:59',
        discount: config?.discount?.value || null,
        threshold: config?.threshold || null,
        limit: config?.limit || null,
        type: id,
        shopIds: shopIds || [],
        valueType,
        products: config?.products || [],
        hasLimit: config?.limit || false,
        marketingCampaignKey
    });

    const toggleLeftSection = (section) => {
        setExpandedLeftSection(prev => (prev === section ? null : section));
    };


    const handleInputChange = (e, field) => {
        if (field === EXPANDABLE_SECTIONS.HASLIMIT && e.target?.checked) {
            setExpandedLeftSection(EXPANDABLE_SECTIONS.LIMIT)
        }
        const value = field === EXPANDABLE_SECTIONS.HASLIMIT ? e.target?.checked : e.target?.value;
        if (value !== undefined) {
            setFormValues(prev => ({ ...prev, [field]: value }));
        }
    };


    const ProductList = useCallback(({ selectedProducts }) => {
        const grouped = _.groupBy(selectedProducts, 'productName');

        return (
            <>
                {_.size(selectedProducts) > 0 ? (
                    <List>
                        {Object.entries(grouped).map(([productName, selectedProducts], groupIndex) => (
                            <React.Fragment key={groupIndex}>
                                {_.map(selectedProducts, (offer, index) => (
                                    <ListItem className="px-1" key={index}>
                                        <Grid container spacing={2} alignItems="center">
                                            <Grid item xs={11}>
                                                <Typography variant="body2">
                                                    1 {productName} <b>acheté</b> ⇒ 1 {offer.productOfferedName} <b>offert</b>
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={1}>
                                                <IconButton
                                                    onClick={() =>
                                                        handleDelete(
                                                            index,
                                                            [setSelectedProducts, setPurchasedProducts, setOfferedProducts, setDisabledPurshasedProducts],
                                                            setFormValues
                                                        )
                                                    }
                                                    aria-label="supprimer"
                                                >
                                                    <DeleteOutlinedIcon />
                                                </IconButton>
                                            </Grid>
                                        </Grid>
                                    </ListItem>
                                ))}


                                {groupIndex < Object.keys(grouped).length - 1 && (
                                    <Divider style={{ backgroundColor: 'rgba(0, 0, 0, 0.12)' }} />
                                )}
                            </React.Fragment>
                        ))}
                    </List>
                ) : (
                    <div
                        style={{
                            textAlign: 'center',
                            padding: 24,
                            backgroundColor: '#fafafa',
                            borderRadius: 4,
                            width: '100%',
                        }}
                    >
                        <Typography variant="body1" color="textSecondary">
                            Aucune offre configurée
                        </Typography>
                        <Typography variant="caption" display="block" style={{ marginTop: 8 }}>
                            Sélectionnez des produits dans la liste à droite pour créer des offres
                        </Typography>
                    </div>
                )}
            </>
        );
    }, []);





    const renderNoCommonProducts = () => {
        return (
            <div className={classes.responsiveContainer}>
                <div className={classes.rightSection} style={{ textAlign: 'center' }}>
                    <Typography variant="caption" display="block" className='py-5'>
                        Aucun produit en commun n'est disponible. Merci de sélectionner à nouveau les points de vente ciblés
                    </Typography>
                </div>
            </div>
        )
    }
    const isDiscountError =
        formValues.discount !== null &&
        (formValues.discount > 100 || formValues.discount <= 0);
    return (
        <Modal
            color="secondary"
            title={title}
            header
            fixed
            size="xl"
            loading={loading}
            btnTxt={`${isUpdate ? 'Modifier ' : 'Lancer '} la campagne `}
            modalBodyClass={`py-0`}
            onClick={() => onClick(formValues)}
            isOpen={showModal}
            handleClose={handleClose}
            width='950px'
            showCancelBtn

        >
            <p className='pt-2'>{description}</p>
            <div className={classes.leftResponsiveContainer}>
                <div className={classes.leftSection} style={{ overflowY: 'auto', maxHeight: '60vh' }}>
                    {(id === PRODUCTDISCOUNT || id === PRODUCTDISCOUNTAFTERTHRESHOLD) ? (
                        <>
                            <StyledAccordion
                                expanded={expandedLeftSection === EXPANDABLE_SECTIONS.DISCOUNT}
                                onChange={() => toggleLeftSection(EXPANDABLE_SECTIONS.DISCOUNT)}
                            >
                                <StyledAccordionSummary className='p-0' expandIcon={<ExpandMoreIcon style={{ color: mainColor.colorBlack }} />}>
                                    <ListItem className='p-0'>
                                        <ListItemText style={{ color: mainColor.colorBlack }} primary={<span className={classes.typo}>{inputText}</span>} />
                                    </ListItem>
                                </StyledAccordionSummary>
                                <AccordionDetails className='p-0'>
                                    <InputField
                                        description={inputDescription}
                                        value={formValues.discount}
                                        onChange={handleInputChange}
                                        field="discount"
                                        valueSymbol='%'
                                        error={isDiscountError}
                                    />
                                </AccordionDetails>
                            </StyledAccordion>
                            <Divider className={classes.dividerStyle} />

                            {id === PRODUCTDISCOUNTAFTERTHRESHOLD && (
                                <>
                                    <StyledAccordion
                                        expanded={expandedLeftSection === EXPANDABLE_SECTIONS.THRESHOLD}
                                        onChange={() => toggleLeftSection(EXPANDABLE_SECTIONS.THRESHOLD)}
                                    >
                                        <StyledAccordionSummary className='p-0' expandIcon={<ExpandMoreIcon style={{ color: mainColor.colorBlack }} />}>
                                            <ListItem className='p-0'>
                                                <ListItemText style={{ color: mainColor.colorBlack }} primary={<span className={classes.typo}>Panier minimum</span>} />
                                            </ListItem>
                                        </StyledAccordionSummary>
                                        <AccordionDetails className='p-0'>
                                            <InputField
                                                description="Pour activer l'offre le client doit dépenser"
                                                value={formValues.threshold}
                                                onChange={handleInputChange}
                                                field="threshold"
                                                valueSymbol='€'
                                                error={formValues.threshold !== null && formValues.threshold <= 0}
                                            />
                                        </AccordionDetails>
                                    </StyledAccordion>
                                    <Divider className={classes.dividerStyle} />
                                </>
                            )}
                        </>
                    ) :


                        <>
                            <StyledAccordion
                                expanded={expandedLeftSection === EXPANDABLE_SECTIONS.PRODUCTLIST}
                                onChange={() => toggleLeftSection(EXPANDABLE_SECTIONS.PRODUCTLIST)}
                            >
                                <StyledAccordionSummary className='p-0' expandIcon={<ExpandMoreIcon style={{ color: mainColor.colorBlack }} />}>
                                    <ListItem className='p-0'>
                                        <ListItemText style={{ color: mainColor.colorBlack }} primary={<span className={classes.typo}>Liste des offres</span>} />
                                    </ListItem>
                                </StyledAccordionSummary>
                                <AccordionDetails className='p-0 pr-1' style={{ display: 'block' }}>
                                    <ProductList selectedProducts={selectedProducts} />
                                </AccordionDetails>
                            </StyledAccordion>
                            <Divider className={classes.dividerStyle} />
                        </>

                    }
                    <StyledAccordion
                        expanded={expandedLeftSection === EXPANDABLE_SECTIONS.DATES}
                        onChange={() => toggleLeftSection(EXPANDABLE_SECTIONS.DATES)}
                    >
                        <StyledAccordionSummary className='p-0' expandIcon={<ExpandMoreIcon style={{ color: mainColor.colorBlack }} />}>
                            <ListItem className='p-0'>
                                <ListItemText style={{ color: mainColor.colorBlack }} primary={<span className={classes.typo}>Dates de l'offre</span>} />
                            </ListItem>
                        </StyledAccordionSummary>
                        <AccordionDetails className='p-0'>
                            <div className={`${classes.section} px-1`}>
                                <DatePickerField
                                    label="Date de début le"
                                    date={formValues.startDate}
                                    time={formValues.startTime}
                                    onDateChange={(date) => handleDateChange(date, 'startDate', setFormValues)}
                                    onTimeChange={(e) => handleInputChange(e, 'startTime')}
                                    minDate={moment().toDate()}
                                />
                                <DatePickerField
                                    label="Date de fin le"
                                    date={formValues.endDate}
                                    time={formValues.endTime}
                                    onDateChange={(date) => handleDateChange(date, 'endDate', setFormValues)}
                                    onTimeChange={(e) => handleInputChange(e, 'endTime')}
                                    minDate={formValues.startDate}
                                />
                            </div>
                        </AccordionDetails>
                    </StyledAccordion>
                    <>
                        <Divider className={classes.dividerStyle} />

                        <StyledAccordion
                            expanded={expandedLeftSection === EXPANDABLE_SECTIONS.LIMIT}
                            onChange={() => toggleLeftSection(EXPANDABLE_SECTIONS.LIMIT)}
                        >
                            <StyledAccordionSummary className='p-0' expandIcon={<ExpandMoreIcon style={{ color: mainColor.colorBlack }} />}>
                                <ListItem className='p-0'>
                                    <ListItemText
                                        style={{ color: mainColor.colorBlack }}
                                        primary={
                                            <Grid container spacing={1} alignItems="center">
                                                <Grid item xs={7}>
                                                    <span className={classes.typo}>Limites d’utilisation par panier</span>
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <Checkbox
                                                        value={formValues.hasLimit}
                                                        onClick={(e) => { e.stopPropagation(); handleInputChange(e, EXPANDABLE_SECTIONS.HASLIMIT) }}
                                                        name="hasLimit"
                                                        color="primary"
                                                    />
                                                </Grid>
                                            </Grid>
                                        }
                                    />
                                </ListItem>
                            </StyledAccordionSummary>
                            <AccordionDetails className='p-0'>
                                <Grid container spacing={1} alignItems="center" className='px-1'>
                                    <Grid item xs={9}>
                                        <Typography variant="body2">Nombre maximal d’utilisations</Typography>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Input
                                            margin='dense'
                                            type='number'
                                            placeholder='1'
                                            value={formValues.limit}
                                            onChange={(e) => handleInputChange(e, EXPANDABLE_SECTIONS.LIMIT)}
                                            style={{ width: '50px' }}
                                            disabled={!formValues.hasLimit}
                                            error={formValues.hasLimit && formValues.limit !== null && formValues.limit <= 0}
                                        />
                                    </Grid>
                                </Grid>
                            </AccordionDetails>
                        </StyledAccordion>
                    </>

                </div>

                {id === BUYONEGETONEDIFFERENTPRODUCT ? (
                    <>
                        {_.size(sections) > 0 ? (
                            <div className={classes.responsiveContainer}>
                                <div className={classes.rightSection} >


                                    <StyledAccordion
                                        expanded={expandedPurchased}
                                        onChange={() => {
                                            setExpandedPurchased(!expandedPurchased);
                                            setExpandedOffered(expandedPurchased);
                                        }}
                                    >
                                        <CustomAccordionSummary
                                            className="p-0"
                                            expandIcon={<ExpandMoreIcon style={{ color: mainColor.colorBlack }} />}
                                        >
                                            <ListItem className="p-0">
                                                <ListItemText
                                                    primary={<span className={classes.typo}>Produit acheté</span>}
                                                />
                                            </ListItem>
                                        </CustomAccordionSummary>
                                        <AccordionDetails className="p-0 pr-2">
                                            <div
                                                className={classes.productsListContainer}
                                                style={{
                                                    flexGrow: 1,
                                                    overflowY: 'auto',
                                                }}
                                            >
                                                {sections.map(section => (
                                                    <div key={section.id}>
                                                        <Typography variant="subtitle2" className={classes.sectionName}>
                                                            {section.name}
                                                        </Typography>
                                                        <Divider />
                                                        <List disablePadding>
                                                            {section.products.map(product => {
                                                                const isSelected = offeredProducts.some(
                                                                    item => item.productKey === product.key
                                                                );
                                                                const isOtherSelected =
                                                                    offeredProducts.length > 0 && !isSelected;
                                                                return (
                                                                    <React.Fragment key={product.key}>
                                                                        <ListItem
                                                                            button
                                                                            onClick={() =>
                                                                                handlePurchasedProductToggle(
                                                                                    product,
                                                                                    section.id,
                                                                                    setOfferedProducts
                                                                                )
                                                                            }
                                                                            className="px-2"
                                                                            disabled={isOtherSelected}
                                                                            style={{
                                                                                display: 'flex',
                                                                                justifyContent: 'space-between',
                                                                                alignItems: 'center',
                                                                                padding: 0,
                                                                            }}
                                                                        >
                                                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                                <ListItemIcon style={{ minWidth: '0px' }}>
                                                                                    <Checkbox
                                                                                        edge="start"
                                                                                        value={isSelected}
                                                                                        disabled={isOtherSelected}
                                                                                        tabIndex={-1}
                                                                                    />
                                                                                </ListItemIcon>
                                                                                <ListItemText
                                                                                    secondary={
                                                                                        <p style={{ color: 'black' }}>{product.name}</p>
                                                                                    }
                                                                                />
                                                                            </div>
                                                                            <ListItemText
                                                                                secondary={
                                                                                    <p style={{ fontSize: '11px' }}>
                                                                                        Prix de vente: {product.price} €
                                                                                    </p>
                                                                                }
                                                                                style={{ textAlign: 'right' }}
                                                                            />
                                                                        </ListItem>
                                                                        <Divider />
                                                                    </React.Fragment>
                                                                );
                                                            })}
                                                        </List>
                                                    </div>
                                                ))}
                                            </div>
                                        </AccordionDetails>
                                    </StyledAccordion>

                                    <StyledAccordion
                                        expanded={expandedOffered}
                                        onChange={() => {
                                            setExpandedOffered(!expandedOffered);
                                            setExpandedPurchased(expandedOffered);
                                        }}
                                    >
                                        <CustomAccordionSummary
                                            className="p-0"
                                            expandIcon={<ExpandMoreIcon style={{ color: mainColor.colorBlack }} />}
                                        >
                                            <ListItem className="p-0">
                                                <ListItemText
                                                    style={{ color: mainColor.colorBlack }}
                                                    primary={<span className={classes.typo}>Produit offert</span>}
                                                />
                                            </ListItem>
                                        </CustomAccordionSummary>
                                        <AccordionDetails className="p-0" style={{ marginRight: '7px !important' }}>
                                            <div
                                                className={`${classes.productsOffredListContainer}`}
                                                style={{
                                                    flexGrow: 1,
                                                    overflowY: 'auto',
                                                }}
                                            >
                                                {sections.map(section => (
                                                    <div key={section.id}>
                                                        <Typography variant="subtitle2" className={classes.sectionName}>
                                                            {section.name}
                                                        </Typography>
                                                        <Divider />
                                                        <List disablePadding>
                                                            {section.products.map(product => {
                                                                const isSelected = offeredProducts.some(item => item.productOfferedKey === product.key);
                                                                const isPurchasedSelected = offeredProducts.some(item => item.productKey === product.key);
                                                                const hasAnyOffered = offeredProducts.some(item => item.productOfferedKey);

                                                                const isOtherSelected = (!isSelected && hasAnyOffered) || isPurchasedSelected;


                                                                return (
                                                                    <React.Fragment key={product.key}>
                                                                        <ListItem
                                                                            button
                                                                            onClick={() =>
                                                                                handleOfferedProductToggle(
                                                                                    product,
                                                                                    section.id,
                                                                                    setOfferedProducts,
                                                                                    offeredProducts,
                                                                                    openErrorModal
                                                                                )
                                                                            }
                                                                            style={{
                                                                                display: 'flex',
                                                                                justifyContent: 'space-between',
                                                                                alignItems: 'center',
                                                                                padding: 0,
                                                                            }}
                                                                            className="px-2"
                                                                            disabled={isOtherSelected}
                                                                        >
                                                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                                <ListItemIcon style={{ minWidth: '0px' }}>
                                                                                    <Checkbox
                                                                                        edge="start"
                                                                                        value={isSelected}
                                                                                        disabled={isOtherSelected}
                                                                                        tabIndex={-1}
                                                                                    />
                                                                                </ListItemIcon>
                                                                                <ListItemText
                                                                                    secondary={
                                                                                        <p style={{ color: 'black' }}>{product.name}</p>
                                                                                    }
                                                                                />
                                                                            </div>
                                                                            <ListItemText
                                                                                secondary={
                                                                                    <p style={{ fontSize: '11px' }}>
                                                                                        Prix de vente: {product.price} €
                                                                                    </p>
                                                                                }
                                                                                style={{ textAlign: 'right' }}
                                                                            />
                                                                        </ListItem>
                                                                        <Divider />
                                                                    </React.Fragment>
                                                                );
                                                            })}
                                                        </List>
                                                    </div>
                                                ))}
                                            </div>
                                        </AccordionDetails>
                                    </StyledAccordion>

                                    {/* ===================== BOUTON ===================== */}
                                    <div className="pt-2">
                                        <Button
                                            onClick={() =>
                                                handleAddOfferedProducts(
                                                    offeredProducts,
                                                    setSelectedProducts,
                                                    setFormValues,
                                                    openErrorModal,
                                                    setOfferedProducts, setExpandedOffered,
                                                    setExpandedPurchased
                                                )
                                            }
                                            disabled={
                                                !offeredProducts.some(item => item.productKey && item.productOfferedKey)
                                            }
                                            style={{ float: 'inline-end', padding: '7px' }}
                                        >
                                            Ajouter une offre
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            renderNoCommonProducts()
                        )}
                    </>

                ) : (
                    <>
                        {_.size(sections) > 0 ?
                            <div className={classes.responsiveContainer}>
                                <div className={classes.rightSection} >


                                    <ListItem className='p-0' style={{ marginTop: '7px' }}>
                                        <ListItemText
                                            style={{ color: mainColor.colorBlack }}
                                            primary={<span className={classes.typo}>Produits concernés par l'offre</span>}
                                        />
                                    </ListItem>
                                    <div className={`${withButton ? classes.defaultListContainer : classes.defaultListContainerWithoutButton}`}>
                                        {!withButton && purchasedProducts.length > 0 && (
                                            <>
                                                <div>
                                                    <Typography variant="body2" className='py-2'>
                                                        <b> *Produits sélectionnés*</b>
                                                    </Typography>
                                                    <Divider />
                                                    <List disablePadding>
                                                        {purchasedProducts.map((product, index) => {
                                                            const sectionName = sections.find(s => s.id === product.productSectionKey)?.name;

                                                            return (
                                                                <React.Fragment key={index}>
                                                                    <ListItem button className='px-2' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: 0 }}>
                                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                            <ListItemText
                                                                                secondary={
                                                                                    <p style={{ color: 'black' }}>
                                                                                        {product.productName}{' '}
                                                                                        <span style={{ color: '#666', fontSize: '0.9em' }}>
                                                                                            ({sectionName})
                                                                                        </span>
                                                                                    </p>
                                                                                }
                                                                            />
                                                                        </div>
                                                                    </ListItem>
                                                                    {index < purchasedProducts.length - 1 && <Divider />}
                                                                </React.Fragment>
                                                            );
                                                        })}
                                                    </List>
                                                </div>
                                                <Divider style={{ margin: '8px 0' }} />
                                            </>
                                        )}
                                        {sections.map(section => {
                                            return (
                                                <div key={section.id}>
                                                    <Typography variant="subtitle2" className={`${classes.sectionName} py-2`}>{section.name}</Typography>
                                                    <Divider />
                                                    <List disablePadding >
                                                        {section.products.map(product => (
                                                            <React.Fragment key={product.key}>
                                                                <ListItem
                                                                    button
                                                                    onClick={() => handleProductToggle(product, section.id, setPurchasedProducts, setFormValues, withButton)}
                                                                    style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: 0 }}
                                                                    className='px-2'
                                                                    disabled={disabledPurshasedProducts.some(item => item.productKey === product.key)}
                                                                >
                                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                        <ListItemIcon style={{ minWidth: '0px' }}>
                                                                            <Checkbox
                                                                                edge="start"
                                                                                value={purchasedProducts.some(item => item.productKey === product.key)}
                                                                                disabled={disabledPurshasedProducts.some(item => item.productKey === product.key)}
                                                                                tabIndex={-1}
                                                                            />
                                                                        </ListItemIcon>
                                                                        <ListItemText secondary={<p style={{ color: 'black' }}>{product.name}</p>} />
                                                                    </div>
                                                                    <ListItemText
                                                                        secondary={<p style={{ fontSize: '11px' }}>Prix de vente: {product.price} €</p>}
                                                                        style={{ textAlign: 'right' }}
                                                                    />
                                                                </ListItem>
                                                                <Divider />
                                                            </React.Fragment>
                                                        ))}
                                                    </List>
                                                </div>
                                            );
                                        })}
                                    </div>
                                    {withButton && (
                                        <div className='pt-2'>
                                            <Button
                                                onClick={() => handleAddProducts(purchasedProducts, setSelectedProducts, setFormValues, setDisabledPurshasedProducts)}
                                                disabled={_.size(purchasedProducts) === 0}
                                                style={{ float: 'inline-end', padding: '7px' }}
                                            >
                                                Ajouter une offre
                                            </Button>
                                        </div>
                                    )}
                                </div></div> :
                            renderNoCommonProducts()}
                    </>
                )}
            </div>
        </Modal>
    );
};

export default withStyles(styles)(CampaignProductsModal);